export default __webpack_public_path__ + "assets/mineAsteroids.6991f209.png";